import * as React from "react";
import { useStaticQuery } from "gatsby";
import * as qs from "qs";
import { LoadingAnimation } from "./LoadingAnimation";
import { getUserJwt } from "../ui/auth/utils";
import { usePathPrefix, removeLeadingSlash } from "../ui/utils";
import { withPathPrefix } from "../utils";
export function useIdpLoginPath(a, b) {
  if (b === void 0) {
    b = {};
  }

  var _b = b,
      c = _b.redirectTo,
      d = _b.loginHint,
      _b$withPathPrefix = _b.withPathPrefix,
      e = _b$withPathPrefix === void 0 ? !0 : _b$withPathPrefix;
  c || "undefined" == typeof window || (c = qs.parse(window.location.search.slice(1)).redirect_to);
  var f = e ? usePathPrefix() : "/";
  "/" === f && (f = "");
  var g = a ? "/" + a : "",
      h = "production" === process.env.NODE_ENV ? f + "/idp-login" + g : f + "/dev-idp-login" + g,
      i = qs.stringify({
    redirect_to: c || null,
    login_hint: d
  }, {
    skipNulls: !0
  });
  return h + (i.length ? "?" + i : "");
}
export function useLoginPageUrl(a, b) {
  if (b === void 0) {
    b = {};
  }

  return console.warn("[warning] useLoginPageUrl is deprecated, use useIdpLoginPath instead"), useIdpLoginPath(a, b);
}

function useCustomLoginPagePath() {
  var _useStaticQuery = useStaticQuery("3743992808"),
      a = _useStaticQuery.siteConfig.customLoginPagePath,
      b = usePathPrefix();

  return a ? withPathPrefix(removeLeadingSlash(a), b) : null;
}

export function RedirectToLogin(_ref) {
  var a = _ref.idpId;
  var b = useCustomLoginPagePath(),
      c = useIdpLoginPath(a);
  return React.useEffect(function () {
    getUserJwt() || window.location.replace((b || c) + ("?redirect_to=" + encodeURIComponent(window.location.pathname)));
  }, []), /*#__PURE__*/React.createElement(LoadingAnimation, {
    stretch: !0
  });
}
export function LoginPageLink(a) {
  var b = useCustomLoginPagePath(),
      c = useIdpLoginPath(a.idpId);
  return /*#__PURE__*/React.createElement("a", {
    href: b || c
  }, a.children);
}